import _get from 'lodash/get';

import { Google, Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById, isHybridVDP, isVDP } from '@/analytics/utilities';
/**
 * @summary Sends GA360 and Pixall events when detail accordion is clicked on the vdp
 * detailSection examples: vehicle-features, certified-pre-owned-program, seller-information, ...
 */
export function inventoryDetailAccordionClick({
    data = {},
    dataLayer,
    state,
}, option) {

    const { inventoryId, detailSection = '', isPsxVdp } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const listingType = _get(inventory, 'listingType', '').toLowerCase();
    const labelSection = detailSection.toLowerCase();
    const cmp = `dropdown::vehicle-features::${labelSection}`;
    const element = `vdp_${listingType}`;

    // Override some pixall data if is psx page
    const psxPixallData = {
        listingType: 'pvt',
        pageId: 'fyc_psx_vdp',
        pixallData: {
            clickTypeToListingType: false,
        },
    };

    Pixall.sendClickEvent({
        eventSource: isHybridVDP(dataLayer) ? 'link' : 'vehicle',
        label: `v_feat_${labelSection}`,
        inventory,
        pixallData: {
            clickTypeToListingType: isVDP(dataLayer),
        },
        ...(isPsxVdp && { ...psxPixallData }),
    }, dataLayer, option);

    if (!isHybridVDP(dataLayer)) {
        Google.sendClickEvent({
            eventElement: element,
            eventResult: cmp,
            eventNonInteractive: true,
        }, option);
    }

    return { cmp, element };
}
